

import { Assets, MigScreen, Starter } from "miglib";
import { MenuScreen } from "./MenuScreen";
import { globals } from "./types";
import { GameScreen } from "./GameScreen";
import { AudioManager } from "./AudioManaget";

const game = new Starter((assets: Assets) => {

    globals.font = game.graphics.sketch.loadFont('assets/font.ttf');
    globals.panelColor = "brown";
    globals.audio = new AudioManager();
    globals.audio.loadMusic("./assets/song.mp3")
    globals.audio.loadSound("dmg", "./assets/sound/dmg.wav")
    globals.audio.loadSound("expl", "./assets/sound/expl.wav")
    globals.audio.loadSound("nope", "./assets/sound/nope.wav")
    globals.audio.loadSound("wird", "./assets/sound/wird.wav")
    globals.audio.loadSound("tick", "./assets/sound/tick.wav")
    globals.audio.loadSound("tock", "./assets/sound/tock.wav")
    globals.audio.loadSound("swoosh", "./assets/sound/swoosh.wav")
    globals.audio.loadSound("move", "./assets/sound/move.wav")
    globals.audio.loadSound("plim", "./assets/sound/plim.wav")
    globals.audio.loadSound("warp", "./assets/sound/warp.wav")

    // ui
    assets.loadImage("panel_purple", "ui/panel_purple.png");
    assets.loadImage("panel_red", "ui/panel_red.png");
    assets.loadImage("panel_yellow", "ui/panel_yellow.png");
    assets.loadImage("panel_green", "ui/panel_green.png");
    assets.loadImage("panel_cyan", "ui/panel_cyan.png");
    assets.loadImage("panel_blue", "ui/panel_blue.png");
    assets.loadImage("panel_gray", "ui/panel_gray.png");
    assets.loadImage("panel_pink", "ui/panel_pink.png");
    assets.loadImage("panel_brown", "ui/panel_brown.png");
    assets.loadImage("panel_white", "ui/panel_white.png");

    assets.loadImage("back", "ui/back.png");
    assets.loadImage("select", "ui/select.png");
    assets.loadImage("square", "ui/square.png");
    assets.loadImage("soul", "ui/soul.png");
    assets.loadImage("blood", "ui/blood.png");
    assets.loadImage("runes", "ui/runes.png");
    assets.loadImage("swap_netherworld", "ui/swap_netherworld.png");
    assets.loadImage("swap_overworld", "ui/swap_overworld.png");
    assets.loadImage("cooldown", "ui/cooldown.png");
    assets.loadImage("cd", "ui/cd.png");
    assets.loadImage("arrow_up", "ui/arrow_up.png");
    assets.loadImage("arrow_down", "ui/arrow_down.png");
    assets.loadImage("arrow_left", "ui/arrow_left.png");
    assets.loadImage("arrow_right", "ui/arrow_right.png");

    // influence
    assets.loadImage("player_influence_border_up", "influence/player_border_up.png");
    assets.loadImage("player_influence_border_down", "influence/player_border_down.png");
    assets.loadImage("player_influence_border_left", "influence/player_border_left.png");
    assets.loadImage("player_influence_border_right", "influence/player_border_right.png");

    assets.loadImage("blue_influence_border_up", "influence/blue_border_up.png");
    assets.loadImage("blue_influence_border_down", "influence/blue_border_down.png");
    assets.loadImage("blue_influence_border_left", "influence/blue_border_left.png");
    assets.loadImage("blue_influence_border_right", "influence/blue_border_right.png");

    assets.loadImage("green_influence_border_up", "influence/green_border_up.png");
    assets.loadImage("green_influence_border_down", "influence/green_border_down.png");
    assets.loadImage("green_influence_border_left", "influence/green_border_left.png");
    assets.loadImage("green_influence_border_right", "influence/green_border_right.png");

    assets.loadImage("influence/player", "influence/player.png");
    assets.loadImage("influence/green", "influence/green.png");
    assets.loadImage("influence/blue", "influence/blue.png");

    // objs
    assets.loadImage("peasant", "objs/peasant.png");
    assets.loadImage("knight", "objs/knight.png");
    assets.loadImage("priest", "objs/priest.png");

    assets.loadImage("house", "objs/house.png");
    assets.loadImage("castle", "objs/castle.png");
    assets.loadImage("chapel", "objs/chapel.png");
    assets.loadImage("tower", "objs/tower.png");
    assets.loadImage("shrine", "objs/shrine.png");

    assets.loadImage("cauldron", "objs/cauldron.png");
    assets.loadImage("machine", "objs/machine.png");
    assets.loadImage("forge", "objs/forge.png");
    assets.loadImage("fire rain", "objs/firerain.png");
    assets.loadImage("conversion ritual", "objs/conversion_ritual.png");

    assets.loadImage("conversion_ritual_gray", "objs/conversion_ritual_gray.png");
    assets.loadImage("cultist_player_gray", "objs/cultist_player_gray.png");
    assets.loadImage("demon_player_gray", "objs/demon_player_gray.png");
    assets.loadImage("fiend_player_gray", "objs/fiend_player_gray.png");
    assets.loadImage("fire rain_gray", "objs/firerain_gray.png");
    assets.loadImage("imp_player_gray", "objs/imp_player_gray.png");
    assets.loadImage("obelisk_player_gray", "objs/obelisk_player_gray.png");
    assets.loadImage("pentagram_player_gray", "objs/pentagram_player_gray.png");
    assets.loadImage("machine_gray", "objs/machine_gray.png");

    assets.loadImage("seat_player", "objs/seat_player.png");
    assets.loadImage("seat_green", "objs/seat_green.png");
    assets.loadImage("seat_blue", "objs/seat_blue.png");
    assets.loadImage("cultist_player", "objs/cultist_player.png");
    assets.loadImage("cultist_green", "objs/cultist_green.png");
    assets.loadImage("cultist_blue", "objs/cultist_blue.png");
    assets.loadImage("imp_player", "objs/imp_player.png");
    assets.loadImage("imp_green", "objs/imp_green.png");
    assets.loadImage("imp_blue", "objs/imp_blue.png");
    assets.loadImage("demon_player", "objs/demon_player.png");
    assets.loadImage("demon_green", "objs/demon_green.png");
    assets.loadImage("demon_blue", "objs/demon_blue.png");
    assets.loadImage("fiend_player", "objs/fiend_player.png");
    assets.loadImage("fiend_green", "objs/fiend_green.png");
    assets.loadImage("fiend_blue", "objs/fiend_blue.png");
    assets.loadImage("pentagram_player", "objs/pentagram_player.png");
    assets.loadImage("pentagram_green", "objs/pentagram_green.png");
    assets.loadImage("pentagram_blue", "objs/pentagram_blue.png");
    assets.loadImage("obelisk_player", "objs/obelisk_player.png");
    assets.loadImage("obelisk_green", "objs/obelisk_green.png");
    assets.loadImage("obelisk_blue", "objs/obelisk_blue.png");

    //tiles overworld
    assets.loadImage("tree1", "tiles/overworld/tree1.png");
    assets.loadImage("tree2", "tiles/overworld/tree2.png");
    assets.loadImage("ocean", "tiles/overworld/ocean.png");

    assets.loadImage("land_full",         /**/ "tiles/overworld/land.png");
    assets.loadImage("land_full_ic_ne",   /**/ "tiles/overworld/land_full_ic_ne.png");
    assets.loadImage("land_full_ic_nw",   /**/ "tiles/overworld/land_full_ic_nw.png");
    assets.loadImage("land_full_ic_se",   /**/ "tiles/overworld/land_full_ic_se.png");
    assets.loadImage("land_full_ic_sw",   /**/ "tiles/overworld/land_full_ic_sw.png");
    assets.loadImage("land_n",            /**/ "tiles/overworld/land_n.png");
    assets.loadImage("land_e",            /**/ "tiles/overworld/land_e.png");
    assets.loadImage("land_s",            /**/ "tiles/overworld/land_s.png");
    assets.loadImage("land_w",            /**/ "tiles/overworld/land_w.png");
    assets.loadImage("land_ne",           /**/ "tiles/overworld/land_ne.png");
    assets.loadImage("land_nw",           /**/ "tiles/overworld/land_nw.png");
    assets.loadImage("land_se",           /**/ "tiles/overworld/land_se.png");
    assets.loadImage("land_sw",           /**/ "tiles/overworld/land_sw.png");

    //tiles nether
    assets.loadImage("rock1", "tiles/netherworld/rock1.png");
    assets.loadImage("rock2", "tiles/netherworld/rock2.png");
    assets.loadImage("lava", "tiles/netherworld/lava.png");

    assets.loadImage("nether_full",         /**/ "tiles/netherworld/nether.png");
    assets.loadImage("nether_full_ic_ne",   /**/ "tiles/netherworld/nether_full_ic_ne.png");
    assets.loadImage("nether_full_ic_nw",   /**/ "tiles/netherworld/nether_full_ic_nw.png");
    assets.loadImage("nether_full_ic_se",   /**/ "tiles/netherworld/nether_full_ic_se.png");
    assets.loadImage("nether_full_ic_sw",   /**/ "tiles/netherworld/nether_full_ic_sw.png");
    assets.loadImage("nether_n",            /**/ "tiles/netherworld/nether_n.png");
    assets.loadImage("nether_e",            /**/ "tiles/netherworld/nether_e.png");
    assets.loadImage("nether_s",            /**/ "tiles/netherworld/nether_s.png");
    assets.loadImage("nether_w",            /**/ "tiles/netherworld/nether_w.png");
    assets.loadImage("nether_ne",           /**/ "tiles/netherworld/nether_ne.png");
    assets.loadImage("nether_nw",           /**/ "tiles/netherworld/nether_nw.png");
    assets.loadImage("nether_se",           /**/ "tiles/netherworld/nether_se.png");
    assets.loadImage("nether_sw",           /**/ "tiles/netherworld/nether_sw.png");

    assets.loadImage("logo", "logo.png");
    assets.loadImage("fullscreen", "fullscreen.png");

    return new MenuScreen();

});

game.start();

export function setCurrentScreen(screen: MigScreen) {
    game.setScreen(screen);
}
